import React from "react";
import { ActiveIntegrateCard } from "components";

export function ActiveTPLinkIntegrations() {
  
  return (
    <ActiveIntegrateCard.Root
        name="TP-Link Omada" 
        subtitle="Wi-Fi" 
        image_url="tp-link-omada.png"
        option={{
            text: "Contact support",
            color: "red",
            onClick: () => {
            const supportEmail = "support@b-connect.co.uk";
            const subject = "TP-Link Support Request";
            const body = "Hello, I need help with TP-Link integration...";
            const mailtoLink = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.location.href = mailtoLink;
        },
      }}
    >
    </ActiveIntegrateCard.Root>
  );
}
